// src/routes/AppRoutes.js

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';

import Home from '../pages/home/Home';
import Batismo from '../pages/batismo/Batismo';
import Noivos from '../pages/noivos/Noivos';
import Capelas from '../pages/capelas/Capelas';
import Sacramentos from '../pages/sacramentos/Sacramentos';
import Solicitacoes from '../pages/solicitacoes/Solicitacoes';
import Dizimo from '../pages/dizimo/Dizimo';
import Doacoes from '../pages/doacoes/Doacoes';
import AdminLogin from '../pages/admin/AdminLogin';
import AdminLayout from '../components/admin/AdminLayout';
import Dashboard from '../pages/admin/Dashboard';
import AdminBatismo from '../pages/admin/AdminBatismo';
import AdminNoivos from '../pages/admin/AdminNoivos';
import AdminSolicitacoes from '../pages/admin/AdminSolicitacoes';
import AdminCapelas from '../pages/admin/AdminCapelas';
import AdminConteudo from '../pages/admin/AdminConteudo';
import AdminDizimo from '../pages/admin/AdminDizimo';
import AdminInformativos from '../pages/admin/AdminInformativos';

const PublicLayout = ({ children }) => (
  <><Navbar />{children}<Footer /></>
);

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
    <Route path="/batismo" element={<PublicLayout><Batismo /></PublicLayout>} />
    <Route path="/noivos" element={<PublicLayout><Noivos /></PublicLayout>} />
    <Route path="/capelas" element={<PublicLayout><Capelas /></PublicLayout>} />
    <Route path="/sacramentos" element={<PublicLayout><Sacramentos /></PublicLayout>} />
    <Route path="/solicitacoes" element={<PublicLayout><Solicitacoes /></PublicLayout>} />
    <Route path="/dizimo" element={<PublicLayout><Dizimo /></PublicLayout>} />  
    <Route path="/doacoes" element={<PublicLayout><Doacoes /></PublicLayout>} />
    <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
    <Route path="/admin/login" element={<AdminLogin />} />

    <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
      <Route path="dashboard"    element={<Dashboard />} />
      <Route path="informativos" element={<AdminInformativos />} />
      <Route path="batismo"      element={<AdminBatismo />} />
      <Route path="noivos"       element={<AdminNoivos />} />
      <Route path="solicitacoes" element={<AdminSolicitacoes />} />
      <Route path="capelas"      element={<AdminCapelas />} />
      <Route path="conteudo"     element={<AdminConteudo />} />
      <Route path="dizimo"       element={<AdminDizimo />} />
      <Route path="doacoes" element={<Doacoes />} />
    </Route>

    <Route path="*" element={
      <PublicLayout>
        <div className="container" style={{ padding: '8rem var(--space-xl)', textAlign: 'center' }}>
          <h2>Página não encontrada</h2>
          <p style={{ margin: '1rem 0 2rem' }}>A página que você está procurando não existe.</p>
          <a href="/" className="btn btn-primary">← Voltar para o início</a>
        </div>
      </PublicLayout>
    } />
  </Routes>
);

export default AppRoutes;